import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { appRoutes } from '@/constants'

export interface AuthLayoutProps {
  title: string
  description?: string
  children: ReactNode
  footer?: ReactNode
}

export function AuthLayout({ title, description, children, footer }: AuthLayoutProps) {
  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden bg-background">
      <div className="pointer-events-none absolute -top-40 left-1/2 h-80 w-[42rem] -translate-x-1/2 rounded-full bg-primary/10 blur-3xl" />

      <div className="relative z-10 mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-4 py-10 sm:px-6">
        <Link to={appRoutes.home} className="mb-8 flex justify-center">
          <img
            src="/images/logo.png"
            alt="Exotic Autocart"
            className="h-16 w-auto object-contain"
          />
        </Link>

        <div className="glass rounded-2xl p-6 shadow-soft sm:p-8">
          <header className="mb-6">
            <h1 className="font-display text-2xl font-bold tracking-tight text-foreground">
              {title}
            </h1>
            {description ? <p className="mt-1.5 text-sm text-muted-foreground">{description}</p> : null}
          </header>

          {children}
        </div>

        {footer ? (
          <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>
        ) : null}
      </div>
    </div>
  )
}
